/*!
 * trigModes.js — what a trig: value means
 * © 2025 Rob Canning — GPLv3
 *
 * A cue's trig: is either one of the built-in modes below, or the uid of an
 * object whose passing fires it. The distinction is decided here and nowhere
 * else, because getting it wrong is silent and total: a mode missing from this
 * list is read as a reference to an object of that name, the cue is registered
 * as a probe target for a source that will never exist, and it is dropped from
 * the playhead list — so it can never fire by any route, with nothing logged.
 *
 * ADDING A MODE MEANS ADDING IT HERE.
 *
 * A leaf module on purpose: probeTriggers.js imports the animation overlay
 * stack, so logic kept there could not be tested outside a browser.
 */

export const KNOWN_TRIGS = new Set([
  "playhead",   // the transport playhead crosses it
  "click",      // a press
  "toggle",     // a press, alternating
  "extent",     // the playhead enters its extent region
  "touch",      // dragged by hand, never self-starting
  "auto",       // starts at load, not the playhead's to start or stop
  "manual",     // started only by another cue
  "osc",        // an incoming OSC address
  "midi",       // an incoming MIDI note/cc/pc
  "none",       // never fires on its own
  "hover",      // pointer over it
  "drag",       // being dragged
  "remote",     // fired by another client
  "edge",       // o2p: starts when the playhead reaches its leading edge
]);

/** A trig: value that names an object rather than a built-in mode. */
export function isObjectTrig(v) {
  if (v == null) return false;
  const s = String(v);
  return !KNOWN_TRIGS.has(s.toLowerCase()) && /^[A-Za-z_][\w-]*$/.test(s);
}
